import { useIntlModule, IntlModuleTypes } from '@enterprise/common';
import messages from './dailyBriefing.intl.json';

export type DailyBriefingIntlKey = IntlModuleTypes.IntlKeys<typeof messages>;
export type DailyBriefingIntlMessages = ReturnType<typeof useDailyBriefingIntl>;

export function useDailyBriefingIntl() {
  return useIntlModule(messages);
}
